import { SOURCE } from "@/constants";
import { ChannelV4 } from "@/types/MentionCard";

export const formatSocialMediaUser = (name: string) => `@${name}`;

export const getShowName = (
  episode: Pick<ChannelV4, "channel_type" | "name">
) => {
  const { channel_type, name } = episode;

  if (!name && channel_type === SOURCE.INSTAGRAM) {
    return formatSocialMediaUser(L.PUBLIC_MENTION_UNKNOWN_INSTAGRAM_USER);
  } else if (
    channel_type === SOURCE.INSTAGRAM ||
    channel_type === SOURCE.TIKTOK ||
    channel_type === SOURCE.TWITTER
  ) {
    return formatSocialMediaUser(name);
  } else {
    return name;
  }
};
